import reviewWorkflows from './review-workflows';

export default {
  'review-workflows': reviewWorkflows,
};
